import { React, useEffect, useState } from "react";
import apartment_list from "../Utils/apartments.json"
import plot_list from "../Utils/plots.json"
import resale from "../Utils/resale.json"
import commercial_list from "../Utils/offices.json"
import AOS from 'aos';

import apartments_icon from "../images/primary/apartments_icon.png"
import sale_icon from "../images/primary/sale_icon.png"
import phone from '../images/phone.png'
import chat_icon from '../images/message.png'
import email_icon from '../images/email.png'
import whatspp from '../images/whatsapp.png'
import zero from '../images/residential/zero.png'
import two from '../images/primary/2percent.png'
import requriement_brief from '../images/residential/requriement_brief.png'
import property_identification from '../images/residential/property_identification.png'
import site_vist from '../images/residential/site_vist.png'
import Negotiation from '../images/residential/Negotiation.png'
import property_registration from "../images/residential/Property_registration.png"
import FAQ from "./FAQ/FAQ";
import Form from "./Form";
import Property_Form from "./Property_Form"
import room_size from "../images/primary/size_room.png"
import size_sqft from "../images/primary/size_sqft.png"
import location_icon from "../images/primary/location.png"
import zero_brokerage from "../images/primary/zero_brokerage_image.png"
import Button from "./Button";
import FormModal from "./FormModal";
import ChatusForm from "./ChatusForm";



function Property({ list }) {

    // Modal State & Function
    const [modalToggle, setModalToggle] = useState(false);
    const [selectedProperty, setSelectedProperty] = useState(null);
    const [calledForm, setCalledForm] = useState("");
    function toggle(property, formName) {
        console.log(property, formName)
        setModalToggle(!modalToggle);
        setSelectedProperty(property);
        setCalledForm(formName)
    }





    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, [])

    let stack = "";
    let title;

    if (list === "apartment") {
        stack = apartment_list;
        title = "Apartments & Villas across Coimbatore";
    } else if (list === "plots") {
        stack = plot_list;
        title = "Plots for Sale in Coimbatore";
    } else if (list === "resale") {
        stack = resale;
        title = "Resale Houses and Villas for sale in Coimbatore"
    } else if (list === "officespace") {
        stack = commercial_list;
        title = "Commercial & Co-working spaces in Coimbatore"
    }

    let seo_data = {
        apartment: {
            section1: {
                title: "Enjoy the untroubled experience of buying new houses in Coimbatore for sale.",
                content: "Your hunt for luxury apartments in Coimbatore can lead you in various directions. At Lands & Lands, our efficient and comprehensive services streamline the home-buying process. Whether you're searching for apartments or villas for sale, our exclusive property listing can make things easy for you.",
                content1: "Our experienced real estate agents can guide you through every step, from property selection to closing the deal and beyond. Start your journey for new homes to buy near you with Lands & Lands.",
                content2: "",
            },
            section2: {
                title: "Helping you find new houses to buy in Coimbatore.",
                content: "Coimbatore is a city that encapsulates the essence of modern living amidst the serenity of South India. The city is known for its blend of industry prowess and natural beauty. Truly a place where culture and commerce come together in harmony.",
                content1: "Lands & Lands invites you to explore a world of luxury apartments and villas in Coimbatore for 60 lakhs. Redefine your standard of living with the all-new homes for sale and low budget apartments for young couples and bigger families.",
                content2: "Our listed properties represent many renowned promoters and developers. Browse the listing or share what's on your mind with our realtors. We will help you find your dream, absolutely hassle-free.",
            },
            cards: [
                {
                    title: "Places To Visit in Coimbatore",
                    content: "Lands & Lands invites you to explore a world of luxury apartments and villas in Coimbatore. Redefine your standard of living with the all-new homes for sale and low budget apartments for young couples and bigger families.",
                },
                {
                    title: "Weather in Coimbatore",
                    content: "Coimbatore's climate is idyllic. The city's pleasant environment ensures your comfort and well-being throughout the year. With mild summers and subtle winters, you can relish the outdoors and enjoy the best of what this city has to offer.",
                },
                {
                    title: "Schools and Education",
                    content: "Investing in your child's education is paramount, and Coimbatore stands out with its prestigious schools and educational institutions. Secure your child's growth and well-being by investing in new houses in Coimbatore for sale. It is a city that values your child's education as much as you do.",
                },
                {
                    title: "Healthcare in Coimbatore",
                    content: "The well-being of your loved ones is in good hands in Coimbatore with top-tier healthcare facilities and hospitals. You can be at ease knowing that quality healthcare services are easily accessible.",
                },
                {
                    title: "Employment Opportunities",
                    content: "The city is home to various industries, including textiles, manufacturing, and IT. Join a dynamic workforce in a city that celebrates progress and innovation. This is also the reason why there are hundreds of flats for sale in Coimbatore for white-collar employees.",
                },
            ]

        },

        plots: {
            section1: {
                title: "With Lands & Lands, find the best land for sale in Coimbatore",
                content: "Your journey to buy land in Coimbatore can often feel like a winding path.",
                content1: "At Lands and Lands, we take stress out of the exhausting process of property investment. Our decade of realtor expertise has helped individuals find low budget land for sale in Coimbatore.",
                content2: "Be it the residential or commercial plots, our exclusive selection can filter your search for the perfect property. Save your valuable time and money in searching plots for sale. Consult Lands & Lands realtors and shorten the journey to buy land in Coimbatore",
            },
            section2: {
                title: "Find your dream plot for sale in Coimbatore",
                content: "Coimbatore beckons with an array of opportunities to explore and settle. Also referred to as the “Manchester of India”. It is nestled in the picturesque landscapes of South India. The city is brimmed with natural beauty and cultural charm.",
                content1: "Whether you are planning to settle in with family or investing to expand your business. We have hundreds of commercial and residential plots for sale listed with us. New to it? Count on our knowledge and experience to find the best 3 cent land for sale in Coimbatore for your investment needs."
            },
            cards: [
                {
                    title: "Places to Visit in Coimbatore",
                    content: "This city beautifully balances industry with natural beauty. Explore its best attractions, from the serene Marudhamalai Temple and the breathtaking Valparai hills to the bustling markets and vibrant cultural festivals. Coimbatore offers a tapestry of experiences for all.",
                },
                {
                    title: "Weather in Coimbatore",
                    content: "Coimbatore enjoys a moderate and pleasant climate throughout the year. It has relatively mild summers and comfortable winters. The weather here is a gift for those seeking a comfortable and enjoyable lifestyle.",
                },
                {
                    title: "Schools and Educations",
                    content: "When it comes to education, Coimbatore is a frontrunner in South India. The city has a wide range of top-tier schools, colleges, and universities that provide world-class education. We have gated community plots for sale in Coimbatore that can secure your entire family.",
                },
                {
                    title: "Healthcare in Coimbatore",
                    content: "The city is known for its robust healthcare infrastructure that includes top-notch hospitals and medical facilities. In fact, investors can buy plots in Coimbatore for developing medical and healthcare facilities.",
                },
                {
                    title: "Employment Opportunities",
                    content: "Coimbatore's booming industries, including textiles, manufacturing, and IT, offer a wealth of employment opportunities. Join a growing workforce in a city that values innovation and progress. It is a perfect city to live in and build your career.",
                },
            ]

        },

        officespace: {
            section1: {
                title: "With Lands & Lands, find your ideal office for rent in Coimbatore",
                content: "Are you looking for an office space for rent in Coimbatore? If yes, Lands & Lands is the best team you can meet with your unique office space needs.",
                content1: "Whether you're an entrepreneur, a startup, or an established corporation, navigating the realm of office space for sale in Coimbatore, our listing can make things easy for you.",
                content2: "Our team of real estate agents collaborates closely with you to gain a comprehensive understanding of the market, ensuring informed decision-making.",
            },
            section2: {
                title: "Office for Rent in Coimbatore: Are They Worth it?",
                content: "Coimbatore, a burgeoning city in Tamil Nadu, is Known for its entrepreneurial spirit and robust industrial landscape.",
                content1: "Renting an office space in Coimbatore comes with a plethora of benefits that outweigh the initial decision-making process. Here are some:",
            },
            cards: [
                {
                    title: "Access to Talent Pool",
                    content: "Coimbatore is home to several educational institutions and industries, attracting a skilled workforce. Renting an office space in this city provides access to this talent pool, facilitating recruitment and fostering a productive work environment.",
                },
                {
                    title: "Strategic Location & Connectivity",
                    content: "Situated in Tamil Nadu, Coimbatore enjoys excellent connectivity via road, rail, and air networks. Its strategic location provides easy access to major cities like Chennai, Bengaluru, and Kochi. Therefore, fostering business expansion opportunities and facilitating logistical convenience for companies.",
                },
                {
                    title: "Flexible Options",
                    content: "There are a variety of office space-for-sale options, ranging from shared coworking spaces to fully equipped private offices. This flexibility allows businesses to choose spaces that align with their needs, whether they require a small, temporary setup or a larger, more permanent office space.",
                },
                {
                    title: "Infrastructure and Amenities",
                    content: "Many commercial spaces available for rent in Coimbatore come equipped with modern infrastructure and amenities. This includes facilities like modern office setups, meeting rooms, and sometimes even access to recreational areas. Renting such spaces saves time and resources on setting up these amenities from scratch.",
                },
                {
                    title: "Quality of Life",
                    content: "Coimbatore boasts a high quality of life with pleasant weather, good infrastructure, educational institutions, healthcare facilities, and a relatively lower pollution rate. This makes it an appealing destination for employees, promoting talent retention and a conducive work environment.",
                },
            ]
        },

        resale: {
            section1: {
                title: "With Lands & Lands find residential plots for sale in Coimbatore.",
                content: "The quest for a new home or resale plots may take you in many directions. But you can place your trust in the experts who have been feeling at home in the real estate industry for over a decade.",
                content1: "At Lands and Lands, we offer end-to-end services that have simplified the process of buying a home, so you can look forward to the memories that are yet to be made.",
                content2: "Be it new apartments, villas, individual lands, or resale plots, we have a selection of inventories from some of the leading brands among the promoters and developers that we represent. Saves you from the hassles of dealing with multiple offerings across brands and locations.",
            },
            section2: {
                title: "Find Prime Residential Land for Sale in Coimbatore",
                content: "Coimbatore a city known as the 'Manchester of India' is more than an industrial hub. Nestled in the scenic landscapes of South India, Coimbatore boasts natural beauty and cultural richness.",
                content1: "Whether you're considering settling with your family or expanding your business investments, we offer a wide range of residential plots for sale. If you're new to this, rely on our expertise to help you find the perfect 3-cent land for your investment requirements in Coimbatore.",
            },
            section3: {
                title: 'Why Invest in Resale Property in Coimbatore?',
                content: "Buying a resale land in Coimbatore comes with own set of advantages that cater to various preferences and needs. Here are some:"
            },
            cards: [
                {
                    title: "Established Neighbourhoods",
                    content: "Coimbatore's older areas boast mature amenities such as schools, hospitals, shopping centres, and recreational facilities. This provides convenience and community that might take years to develop in newer locations.",
                },
                {
                    title: "Potential for Renovation",
                    content: "Resale properties offer an opportunity for customisation and renovation according to personal preferences. Whether it's modernizing the interior design, or adding personalized touches, purchasing a resale plot or land allows for more freedom to tailor the space.",
                },
                {
                    title: "Value Appreciation",
                    content: "Older properties in Coimbatore often come with a more stable pricing structure, offering potential negotiation leverage. Additionally, these resale properties might have already undergone significant appreciation, offering a more predictable investment scenario",
                },
                {
                    title: "Established Landscaping & Green Spaces",
                    content: "Resale properties often come with established gardens, landscaping, and mature trees. This offers an immediate connection to nature that might take years to cultivate in new developments. Also adds both aesthetic value and a sense of tranquillity to the property.",
                },
                {
                    title: "Reducing waiting time for Posession",
                    content: "Unlike buying off-plan properties or new developments, purchasing a resale property typically involves a shorter waiting time for possession. This is especially advantageous for those looking to move in or start utilizing the property sooner rather than later."
                },
            ]
        }


    };

    let temporary_data = [
        {
            title: "Retail Space",
            content: "Ideal for businesses seeking direct consumer interaction. Retail spaces for rent in Coimbatore offer high visibility and foot traffic opportunities.",
        },
        {
            title: "Commercial Building",
            content: "Versatile and often customizable, commercial buildings for rent cater to a wide array of business needs. This provides ample space for operations and expansion.",
        },
        {
            title: "Tech Park",
            content: "These state-of-the-art facilities are a haven for tech-centric businesses, fostering innovation and collaboration within a tech-savvy environment.",
        },
        {
            title: "Warehouse",
            content: "For enterprises requiring storage or distribution facilities, warehouses for lease in Coimbatore are ideal solutions, equipped with modern amenities.",
        },
        {
            title: "Furnished Office Space",
            content: "Convenience meets functionality with fully furnished office spaces for rent. This streamlined the setup process and allowed businesses to hit the ground running. Explore our listings or simply share your vision with our experienced realtors. Let us guide you through the seamless process of securing your ideal workspace in Coimbatore.",
        },
    ];

    const process = [
        {
            icons: requriement_brief,
            heading: "Requirement Brief",
            id: "1"
        },
        {
            icons: property_identification,
            heading: "Property Identification",
            id: "2"
        },
        {
            icons: site_vist,
            heading: "Site Visit"
        },
        {
            icons: Negotiation,
            heading: "Negotiation"
        },
        {
            icons: property_registration,
            heading: "Property Registration"
        },
    ]


    return (
        <>
            {/* <ChatusForm /> */}
            {/* Floating Bottom bar */}
            <div className="font-alibaba text-font-grey fixed bottom-4 left-1/2 -translate-x-1/2 bg-white rounded-lg flex items-center gap-x-10 sm:gap-x-14 py-4 px-7 border-[0.50px] border-[#BABABA] shadow-2xl opacity-100 !z-10">

                <a href="tel:+919280234436" target="_blank">
                    <div className="flex items-center gap-x-2 group hover:scale-110 transition duration-150 ease-in-out">
                        <img className="w-[18px] h-[20px] opacity-50 group-hover:opacity-100" src={phone} alt="icons " />
                        <p className="text-[16px]">Call</p>
                    </div>
                </a>

                <div className="flex items-center gap-x-2 group  hover:scale-110 transition duration-150 ease-in-out cursor-pointer" onClick={() => {toggle(null, 3)}}>
                    <img className="w-[20px] h-[20px] opacity-50 group-hover:opacity-100" src={whatspp} alt="icons " />
                    <p className="text-[16px]">Whatsapp</p>
                </div>


                <div className="flex items-center gap-x-2 group cursor-pointer hover:scale-110 transition duration-150 ease-in-out" onClick={toggle}>
                    <img className="w-[20px] h-[18px] opacity-50 group-hover:opacity-100" src={email_icon} alt="icons " />
                    <p className="text-[16px]">Enquire</p>
                </div>

            </div>


            <div className="bg-white" id="property-section">

                <div className="max-w-[1337px] mx-auto w-fit py-16 sm:py-32" >
                    <h1 className="heading max-w-[850px] mx-auto" data-aos="fade-up">{title}</h1>
                    <hr className='border-yellow border-[2px] w-[87px] mx-auto my-5' data-aos="fade-up" data-duration="1000" />

                    <div className="grid grid-cols-1 sm:grid-cols-2 mx-auto w-fit xl:grid-cols-4 items-center gap-x-7 xl:gap-x-5 gap-y-12 mt-20">
                        {stack.map((items) => {
                            return (
                                // Muhil code 
                                // <div className="bg-white w-[97%] mx-auto h-[640px] relative sm:w-[420px] shadow-lg rounded-[8px] pb-7" data-aos="fade-up">

                                //     <div className="relative">
                                //         <img src={items.image} alt="property_images" className="w-full h-[244px]" />
                                //         <p className="font-alibaba text-[16px] font-normal leading-[28px] px-[8px] py-[4px] w-fit bg-yellow text-hblack absolute top-3 right-3">{items.status}</p>
                                //     </div>

                                //     <div className="px-4 mt-3">
                                //         <h2 className="font-noto text-[20px] leading-[30px] sm:text-[26px] text-hblack font-semibold sm:leading-[40px]">{items.name}</h2>

                                //         <div className="absolute bottom-12 sm:bottom-9 ">
                                //             {/* Location */}
                                //             <div className="flex flex-row items-center gap-x-3 ">
                                //                 <img src={location_icon} alt="location-icon" className="w-[18px] h-[25px]" />
                                //                 <p className="font-alibaba text-font-grey text-[16px] leading-[24px] sm:text-[18px] font-normal sm:leading-[28px]">{items.detail}</p>
                                //             </div>

                                //             {/* Sizing */}
                                //             <div className="flex flex-row items-center justify-between w-full flex-nowrap mt-5">
                                //                 <div className={list === "resale" ? "hidden" : "flex flex-row items-center gap-x-2"}>
                                //                     <img src={room_size} alt="room-size-icon" className="w-[25px] h-[18px]" />
                                //                     <p className="font-alibaba text-[18px] sm:text-[20px] font-semibold leading-[28px] text-font-grey uppercase">{items.type}</p>
                                //                 </div>

                                //                 <div className="flex flex-row items-center gap-x-2">
                                //                     <img src={size_sqft} alt="sqft-size-icon" className="w-[14px] h-[17px]" />
                                //                     <p className="font-alibaba text-[18px] sm:text-[20px] text-font-grey leading-[28px] font-semibold">{items.area}</p>
                                //                 </div>
                                //             </div>

                                //             <hr className="border-[#E5E5E5] border-t-[2px] w-full my-5" />

                                //             {/* Pricing & Status */}
                                //             <div className="flex flex-row items-end justify-between">
                                //                 <h4 className="font-alibaba font-bold text-[36px] text-brown font-bold leading-[33.6px]">₹ {items.price}</h4>
                                //                 <p className="font-alibaba text-font-grey text-[14px] font-normal leading-[28px]">{items.exclusive}</p>
                                //             </div>

                                //             {/* Card Buttons */}
                                //             <div className="w-full flex flex-row items-center justify-between mt-12 gap-x-3 sm:gap-x-7">
                                //                 <button class={` group relative overflow-hidden px-7 py-3 transition-colors duration-500 bg-[#F5D000] sm:px-9`} onClick={() => { toggle(items.name) }}>
                                //                     <h3 class={`font-alibaba font-bold font-medium text-[16px] text-black relative z-10 transition-colors duration-500 group-hover:text-white`}>Enquire Now</h3>
                                //                     <span class={`absolute inset-0 origin-left scale-x-0 transform transition-transform duration-500 ease-in group-hover:scale-x-100 bg-brown`}></span>
                                //                 </button>
                                //                 <Button
                                //                     name={"Chat with us"}
                                //                     design={"unfilled"}
                                //                     action={"external-linking"}
                                //                     url={`https://wa.me/8925837928?text=Hello! I am looking for ${items.name}`}
                                //                 />
                                //             </div>
                                //         </div>
                                //     </div>

                                // </div>


                                // Prithiv code - New card design
                                <div className="bg-white w-[90%] mx-auto relative sm:w-[320px] h-[490px] shadow-lg rounded-[8px] pb-7 cursor-pointer" data-aos="fade-up" >

                                    <div className="relative">
                                        <img src={items.image} alt="property_images" className="w-full h-[186px]" />
                                        <p className="font-alibaba text-[12px] font-normal leading-[28px] px-[8px] py-[4px] w-fit bg-yellow text-hblack absolute top-3 right-3">{items.status}</p>
                                    </div>

                                    <div className="px-4 mt-3">
                                        <h2 className="font-noto text-[20px] leading-[32px] text-hblack font-bold">{items.name}</h2>

                                        <div className="absolute bottom-3 left-0 w-full px-4 pb-4">
                                            {/* Location */}
                                            <div className="flex flex-row items-center gap-x-3 ">
                                                <img src={location_icon} alt="location-icon" className="w-[18px] h-[25px]" />
                                                <p className="font-alibaba text-font-grey text-[16px] leading-[24px] sm:text-[14px] font-normal sm:leading-[28px]">{items.detail}</p>
                                            </div>

                                            {/* Sizing */}
                                            <div className="flex flex-row items-center justify-between w-full flex-nowrap mt-3">
                                                <div className={list === "resale" || list === "officespace" ? "hidden" : "flex flex-row items-center gap-x-2"}>
                                                    <img src={room_size} alt="room-size-icon" className="w-[25px] h-[18px]" />
                                                    <p className="font-alibaba text-[18px] sm:text-[15px] font-semibold leading-[28px] text-font-grey uppercase">{items.type}</p>
                                                </div>

                                                <div className="flex flex-row items-center gap-x-2">
                                                    <img src={size_sqft} alt="sqft-size-icon" className="w-[14px] h-[17px]" />
                                                    <p className="font-alibaba text-[18px] sm:text-[15px] text-font-grey leading-[28px] font-semibold">{items.area}</p>
                                                </div>
                                            </div>

                                            <hr className="border-[#E5E5E5] border-t-[2px] w-full my-3" />

                                            {/* Pricing & Status */}
                                            <div className="flex flex-row items-end justify-between">
                                                <h4 className="font-alibaba font-bold text-[22px] text-brown font-bold leading-[33.6px]">₹ {items.price}</h4>
                                                <p className="font-alibaba text-font-grey text-[14px] font-normal leading-[28px]">{items.exclusive}</p>
                                            </div>

                                            {/* Card Buttons */}
                                            <div className="w-full flex flex-row items-center justify-between mt-6 gap-x-3 sm:gap-x-5">
                                                <button class={` group relative overflow-hidden w-[136px] h-[40px] transition-colors duration-500 bg-[#F5D000] `} onClick={() => { toggle(items.name, 1) }}>
                                                    <h3 class={`font-alibaba font-bold font-medium text-[13px] text-black relative z-10 transition-colors duration-500 group-hover:text-white`}>Enquire Now</h3>
                                                    <span class={`absolute inset-0 origin-left scale-x-0 transform transition-transform duration-500 ease-in group-hover:scale-x-100 bg-brown`}></span>
                                                </button>

                                                <a href="tel:+919280234436" >
                                                    <button type="button" class={` group relative overflow-hidden w-[136px] h-[40px] transition-colors duration-500 border-[1.5px] border-[#F5D000]`}>
                                                        <h3 class={`font-alibaba font-bold font-medium text-[13px] text-black relative z-10 transition-colors duration-500 group-hover:text-black`}>Call us</h3>
                                                        <span class={`absolute inset-0 origin-left scale-x-0 transform transition-transform duration-500 ease-in group-hover:scale-x-100 bg-[#F5D000]`}></span>
                                                    </button>
                                                </a>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>

            {/* Zero brokerage Section */}
            <div className="max-w-6xl mx-auto my-[80px] bg-[#F8F6F6] p-6 sm:p-16">
                <div className="flex flex-wrap justify-center items-center gap-x-[50px]">
                    <img src={zero_brokerage} alt="zero_brokerage_image" className="sm:w-[419px] sm:h-[497px]" data-aos="fade-up" />

                    <div className="max-w-full flex flex-col items-center">
                        <h1 className="font-noto text-hblack text-[36px] text-center font-bold leading-[47px]" data-aos="fade-up">Zero Brokerage for buyers!</h1>
                        <p className="font-alibaba text-[20px] text-font-grey leading-[30px] font-normal text-center mt-3" data-aos="fade-up">*Property shortlisted from our listed inventory</p>

                        <h3 className="font-alibaba font-bold text-[20px] font-semibold leading-[30px] text-center text-font-grey max-w-[465px] mx-auto mt-7 mb-16" data-aos="fade-up">0% brokerage on new properties with lowest price assurance. 100% customer delight.</h3>

                        <Button
                            name={"Enquire Now"}
                            design={"filled"}
                            action={"modal-open"}
                            modalfunction={toggle}

                        />
                    </div>
                </div>
            </div>


            {/* Service Description */}
            <div className="max-w-7xl mx-auto my-20">
                <div className='max-w-[770px] mx-auto my-20'>
                    <h1 className='heading' data-aos="fade-up">One Stop Destination </h1>
                    <hr className='border-yellow border-[2px] w-[87px] mx-auto my-5' data-aos="fade-up" data-aos-duration="800" />
                    <p className="service-description max-w-[722px] mx-auto" data-aos="fade-up" data-aos-duration="1100">Explore your dream property from our exclusively curated Apartments,  Villas & Plots from CREDAI certified A-Grade Developers. Save you  time & energy with our one stop shop.</p>
                </div>

                <div className="flex flex-col sm:flex-row items-center justify-center gap-x-12 sm:flex-wrap gap-y-12 ">
                    <div className=" flex flex-col items-center bg-white px-[30px] pt-[40px] pb-[55px] shadow-xl w-[294px] h-[533px] gap-y-9 relative" data-aos="fade-up" data-aos-duration="800">
                        <img src={apartments_icon} alt="apartment_icon" className="w-[74px] h-[73px]" />

                        <h1 className="font-noto text-hblack text-[26px] font-bold leading-[40px] text-center text-wrap ">Apartments & Villas</h1>
                        <p className="font-alibaba text-[18px] text-font-grey font-normal leading-[26px] text-center ">Check new houses for sale in Coimbatore at Lands and Lands. Buy Luxury apartments and flats hassle-free.</p>

                        <div className="absolute w-fit bottom-10">
                            <Button
                                name={"Explore Now"}
                                design={"unfilled"}
                                action={"internal-linking"}
                                pageLink={"/apartments-and-villas-for-sale-in-coimbatore"}
                            />
                        </div>

                    </div>

                    <div className=" flex flex-col items-center bg-white px-[30px] pt-[40px] pb-[55px] shadow-xl w-[294px] h-[533px] gap-y-9 relative" data-aos="fade-up" data-aos-duration="1200">
                        <img src={sale_icon} alt="apartment_icon" className="w-[74px] h-[73px]" />

                        <h1 className="font-noto text-hblack text-[26px] font-bold leading-[40px] text-center text-wrap ">Sale Plots & Residences</h1>
                        <p className="font-alibaba text-[18px] text-font-grey font-normal leading-[26px] text-center w-[250px]">Lands and Lands offers low budget land for sale in Coimbatore.</p>

                        <div className="absolute w-fit bottom-10">
                            <Button
                                name={"Explore Now"}
                                design={"unfilled"}
                                action={"internal-linking"}
                                pageLink={"/plots-for-sale-in-coimbatore"}
                            />
                        </div>

                    </div>

                    <div className=" flex flex-col items-center bg-white px-[30px] pt-[40px] pb-[55px] shadow-xl w-[294px] h-[533px] gap-y-9 relative" data-aos="fade-up" data-aos-duration="1600">
                        <img src={apartments_icon} alt="apartment_icon" className="w-[74px] h-[73px]" />

                        <h1 className="font-noto text-hblack text-[26px] font-bold leading-[40px] text-center text-wrap ">Resale<br />Houses & Villas</h1>
                        <p className="font-alibaba text-[18px] text-font-grey font-normal leading-[26px] text-center w-[250px]">Resale Houses and Villas for sale around Coimbatore.</p>

                        <div className="absolute w-fit bottom-10">
                            <Button
                                name={"Explore Now"}
                                design={"unfilled"}
                                action={"internal-linking"}
                                pageLink={"/buy-house-in-coimbatore"}
                            />
                        </div>

                    </div>


                    {/* <div className=" flex flex-col items-center bg-white px-[30px] pt-[40px] pb-[55px] shadow-xl w-[294px] h-[533px] gap-y-9 relative">
                        <img src={apartments_icon} alt="apartment_icon" className="w-[74px] h-[73px]" />

                        <h1 className="font-noto text-hblack text-[26px] font-bold leading-[40px] text-center text-wrap ">Rent <br /> Office Space</h1>
                        <p className="font-alibaba text-[18px] text-font-grey font-normal leading-[26px] text-center w-[250px]">Get office space for rent in Coimbatore. Lease office space for rent, fast and hassle-free.</p>

                        <div className = "absolute w-fit bottom-10"> 
                            <Button
                            name = {"Explore Now"}
                            design = {"unfilled"}
                            action = {"internal-linking"}
                            pageLink = {"/residential/apartments-and-villas-for-sale-in-coimbatore"}
                        />
                        </div>

                    </div> */}
                </div>


            </div>


            <FAQ name={list} />

            <FormModal
                modal={modalToggle}
                active={toggle}
                property={selectedProperty}
                form={calledForm}
            />



        </>
    )
}

export default Property;